<template lang="pug">
    section#funciona
        div.wrapper
            h2 Vai funcionar assim:
            ul
                li
                    div.img
                        img(:src="require('@images/transferencia/icone-transferencia.png')")
                    p
                        |Faça a sua Transferência de outra Instituição de ensino superior para a UniFAEL.
                li
                    div.img
                        img(:src="require('@images/transferencia/icone-economia.png')")
                    p
                        |E ganhe bolsas de desconto de até 45% aplicada a todas as mensalidades até o final do curso de graduação!
                        sup 2

                li
                    div.img
                        img(:src="require('@images/transferencia/icone-calendario.png')")
                    p
                        |E pode economizar ainda mais! Basta pagar as mensalidades até o dia 5 e garantir o maior Desconto Pontualidade concedido pela UniFAEL.
                    div.destaque
                        p
                            |Assim, você pode
                            span ganhar até 60%
                            |de desconto!
</template>

<script>
export default {
    name: "section-funciona"
}
</script>

<style lang="stylus" scoped src="./Funciona.styl"></style>
